import { formatCurrency }             from 'helpers/common.helper';
import { dateRefClaim, medicalBill }  from './ClaimStatics';

// Patient Information Section
export const claimDetailsElements = (props) => {
  const details   = props.data;
  const isGeneral = props.category !== 'Optical';
  const isOptical = props.category === 'Optical';

  const diagnosis = details.diagnosis.map(function(hash){
    return(hash.name)
  }).join(', ');

  const services = details.services.map((hash, index) => {
    return(
      <div className="d-flex justify-content-between" key={ hash.id }>
        <p><b>{ hash.name }</b></p>
        <p><b>{ 'MYR ' + formatCurrency(hash.fee) }</b></p>
      </div>
    )
  });

  const medications = details.medications.map((hash, index) => {
    const total_price = hash.unit_price * hash.quantity;

    return(
      <tr key={ hash.id }>
        <td><p><b>{ hash.name }</b></p></td>
        <td><p className="text-right"><b>{ hash.quantity }</b></p></td>
        <td><p className="text-right"><b>{ 'MYR ' + formatCurrency(hash.unit_price) }</b></p></td>
        <td><p className="text-right"><b>{ 'MYR ' + formatCurrency(total_price) }</b></p></td>
      </tr>
    )
  });

  const eyewearsSize = details.eyewears.length;

  const eyewears = details.eyewears.map((hash, index) => {
    const hasBorder = index + 1 < eyewearsSize ? 'pb-2 mb-6 border-bottom' : '';
    return(
      <div className={ hasBorder } key={ hash.id }>
        <div className="d-flex justify-content-between">
          <p><b>{ hash.name }</b></p>
          <p><b>{ 'MYR ' + formatCurrency(hash.unit_price) }</b></p>
        </div>

        <p className="text-lightgrey mb-0 font-size-3">Description/Prescription/Remarks</p>
        <p><b>{ hash.description || '-' }</b></p>
      </div>
    )
  });

  return (
    <div className="mb-3">
      <div className="row mb-6">
        { dateRefClaim(details, props.status, props.color) }
      </div>

      <h6 className="modal-section-header px-4 py-3 my-6">Medical Bill</h6>
      { medicalBill(details, props.category) }

      {/* General Section */}
      <span className="conditional-display" displayed={ isGeneral.toString() }>
        <h6 className="modal-section-header px-4 py-3 my-6">Medical Cert</h6>
        <p className="text-lightgrey mb-0 font-size-3">Number of Medical Cert Day(s)</p>
        <p><b>{ details.medical_certificate_days }</b></p>

        <h6 className="modal-section-header px-4 py-3 my-6">Diagnoses / Diseases</h6>
        <p><b>{ diagnosis }</b></p>

        <h6 className="modal-section-header px-4 py-3 my-6">Services / Procedures</h6>
        { services }

        <p className="text-lightgrey mb-0 font-size-3">Doctor's Note</p>
        <p><b className="multiline-text">{ details.provider_notes || '-' }</b></p>

        <h6 className="modal-section-header px-4 py-3 my-6">Medications</h6>

        <table className="w-100">
          <thead>
            <tr>
              <td></td>
              <td><p className="text-lightgrey text-right font-size-3">Quantity</p></td>
              <td><p className="text-lightgrey text-right font-size-3">Price/Unit (MYR)</p></td>
              <td><p className="text-lightgrey text-right font-size-3">Total</p></td>
            </tr>
          </thead>

          <tbody>
            { medications }
          </tbody>
        </table>
      </span>

      {/* Optical Section */}
      <span className="conditional-display" displayed={ isOptical.toString() }>
        <h6 className="modal-section-header px-4 py-3 my-6">Services / Procedures</h6>
        { eyewears }
      </span>

      <div className="d-flex justify-content-end align-items-baseline modal-section-header bg-grey px-4 py-5 my-6 font-size-7">
        <b className="fweight-500">Grand Total</b>
        <b className="fweight-400 ml-4">MYR</b>
        <span className="ml-6">{ formatCurrency(details.total_amount) }</span>
      </div>
    </div>
  )
}